import React from 'react';
import ReminderSpecificActivities from './ReminderSpecificActivities'

import '../../App.css';
import '../../bootstrap.css';

export default class ReminderHour extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editingIntro: false,
      newIntro: ''
    }

    let firstName = this.props.userName.split(' ')[0];
    this.defaultIntro = "Hey " + firstName + "!";

    this.introEdit = this.introEdit.bind(this);
    this.introSave = this.introSave.bind(this);
    this.introCancel = this.introCancel.bind(this);
    this.introChange = this.introChange.bind(this);

    this.uncollapse = this.uncollapse.bind(this);
    this.collapse = this.collapse.bind(this);
  }

  componentDidMount() {
    this.refresh(this.props);
  }

   refresh(nextProps) {
    if (nextProps.hideDisabled) {
      if (nextProps.hourItems.custom) {
        let customItems = nextProps.hourItems.custom;
        let keys = Object.keys(customItems);

        for (let i = 0; i < keys.length; i++) {
          if (!customItems[keys[i]].disabled) {
            this.setState({ collapsed: false });  
            return;
          }
        }
      }

      // Remove all this stuff eventually
      if (nextProps.hourItems.exercise && nextProps.hourItems.exercise.generic) {
        let customItems = nextProps.hourItems.exercise.generic;
          if (!customItems.disabled) {
            this.setState({ collapsed: false });  
            return;
          }
      }

      if (nextProps.hourItems.food && nextProps.hourItems.food.generic) {
        let customItems = nextProps.hourItems.food.generic;
          if (!customItems.disabled) {
            this.setState({ collapsed: false });  
            return;
          }
      }

      if (nextProps.hourItems.feeling && nextProps.hourItems.feeling.generic) {
        let customItems = nextProps.hourItems.feeling.generic;
          if (!customItems.disabled) {
            this.setState({ collapsed: false });  
            return;
        }
      }
      this.setState({ collapsed: true });  
    } else {
      this.setState({ collapsed: false });  
    }
  }

  collapse(e) {
    e.preventDefault();
    this.setState({collapsed: true});
  }

  uncollapse(e) {
    e.preventDefault();
    this.setState({collapsed: false});
  }

  introEdit(e) {
    e.preventDefault();
    this.setState({
      editingIntro: true,
      newIntro: this.props.hourItems.intro ? this.props.hourItems.intro : this.defaultIntro
    });
  }

  introChange(e) {
    e.preventDefault();
    this.setState({newIntro: e.target.value});
  }

  introSave(e) {
    e.preventDefault();
    this.props.firebase.database().ref(e.target.name).set(this.state.newIntro);
    this.setState({editingIntro: false, newIntro: ""});
    this.props.refresh();
  }

  introCancel(e) {
    e.preventDefault();
    this.setState({editingIntro: false, newIntro: ""});
  }

  render() {
    let collapseButton = this.state.collapsed ? (<input type="submit" onClick={this.uncollapse} value="Show"/>) :
      ((<input type="submit" onClick={this.collapse} value="Hide"/>));
      
    if (this.state.collapsed) {
      return (
        <span>
          {collapseButton}
        </span>
      )
    } else {
      let intro;
      if (this.state.editingIntro) {
        intro = this.props.hourItems.intro ?
          (<li>
            Intro: <input value={this.state.newIntro} onChange={this.introChange}/>
            <input type="submit" name={this.props.path + '/intro'} onClick={this.introSave} value="Save"/>
            <input type="submit" onClick={this.introCancel} value="Cancel"/>
          </li>) :
          (<li>
            Intro: <input value={this.state.newIntro} onChange={this.introChange}/>
            <input type="submit" name={this.props.path + '/intro'} onClick={this.introSave} value="Save"/>
            <input type="submit" onClick={this.introCancel} value="Cancel"/>
          </li>);
      } else {
        intro = this.props.hourItems.intro ?
          (<li>
            Intro: "{this.props.hourItems.intro}" <input type="submit" onClick={this.introEdit} value="Edit"/>
          </li>) :
          (<li>
            Intro: {this.defaultIntro} <input type="submit" onClick={this.introEdit} value="Edit"/>
          </li>);
      }

      let custom = this.props.hourItems.custom ?
        (<li>Custom <ReminderSpecificActivities hourPath={this.props.path} path={this.props.path + '/custom'} specificActivities={this.props.hourItems.custom}
          firebase={this.props.firebase} refresh={this.props.refresh}
          hideDisabled={this.props.hideDisabled}/></li>) : (<span />);
      
      let minuteItems = [];
      for (let i = 1; i < 60; i++) {
        if (this.props.hourItems[i] && this.props.hourItems[i].custom) {
          minuteItems.push({
            key: i,
            content: (<ReminderSpecificActivities hourPath={this.props.path} path={this.props.path + '/' + i + '/custom'} specificActivities={this.props.hourItems[i].custom}
            firebase={this.props.firebase} refresh={this.props.refresh} workoutsMap={this.props.workoutsMap}
            dailyHabitsMap={this.props.dailyHabitsMap} weeklyHabitsMap={this.props.weeklyHabitsMap}
            hideDisabled={this.props.hideDisabled}/>)
          });
        }
      }

      return (
        
        <span>
          {collapseButton}
          <ul>
            {intro}
            {custom}
            {minuteItems.map((minute) =>
              <li key={minute.key}><b>Minute {minute.key}</b>
                <ul>
                  {minute.content}
                </ul>
              </li>
            )}
          </ul>
        </span>
      )
    }
  }
}


// WEBPACK FOOTER //
// ./src/main/reminders/ReminderHour.js